import React from "react"
import Signup from "./Signup"
import Dashboard from "./Dashboard"
import Login from "./Login"

import { AuthProvider } from "../contexts/AuthContext"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import Profile from "./Profile"
import PrivateRoute from "./PrivateRoute"
import UpdateProfile from "./UpdateProfile"
import Inventory from "./Inventory"

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route element={<PrivateRoute />}>
            <Route exact path="/" element={<Dashboard />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/update-profile" element={<UpdateProfile />} />
            <Route path="/inventory" element={<Inventory />} />
          </Route>
          <Route path="/signup" element={<Signup />} />
          <Route path="/login" element={<Login />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;